<template>
    <div class="me">
        <div class="header">
            <p>我的</p>
        </div>
        <!--@click="$router.push('Personal')"-->
        <div class="user-info">
            <div class="user-header">
                <img :src="PersonalImgUrl" @error="ImgError">
            </div>
            <div class="user-text">
                <p>{{ `${this.$UserInfo.DepartmentName}(${this.$UserInfo.StoreName})` }}</p>
                <p>{{ this.$UserInfo.UserName }}</p>
            </div>
            <!-- <div class="user-right">
                <img src="../../assets/img/right.png">
            </div> -->
        </div>
        <div class="content">
            <div @click="jump('setting')">
                <img src="../../assets/img/setting.png">
                <span>相关设置</span>
                <img src="../../assets/img/right.png">
            </div>
            <div @click="TrainShow = true" v-if="$UserInfo.UserId === 'admin' && $route.query.ZLYY == '1'">
                <img src="../../assets/img/SendFile.png">
                <span>提取文件</span>
                <img src="../../assets/img/right.png">
            </div>
            <!-- <div @click="jump('about')">
                <img src="../../assets/img/info.png">
                <span>关于我们</span>
                <img src="../../assets/img/right.png">
            </div> -->
            <!-- <div @click="BindWx()">
                <img src="../../assets/img/BindWx.png">
                <span style="padding-bottom: 10px;">绑定微信</span>
                <img src="../../assets/img/right.png">
            </div> -->
        </div>
        <transition name="fade">
            <van-popup v-model="TrainShow" round position="bottom" :style="{ width: '100%', height: '30%' }">
                <div class="contentkey">
                    <p>请输入密钥</p>
                    <input type='password' v-model="value" />
                    <div @click="SubmitKey">确定</div>
                </div>
            </van-popup>
        </transition>

        <transition name="fade">
            <van-popup v-model="Show" round position="bottom" :style="{ width: '100%', height: '30%' }">
                <van-cell>
                    <template>
                        <div class="contentButton">
                            <div @click="Delete">删除API下web异常日志</div>
                            <div @click="DownloadWebFile">下载web异常日志</div>
                            <div>
                                <input type='text' v-model="APIFile" />
                                <div @click="Download">下载api日志</div>
                                <div @click="UpdateRegistration">更新注册码</div>
                            </div>
                        </div>
                    </template>
                </van-cell>
            </van-popup>
        </transition>
    </div>
</template>

<script>
import {
    Popup,
    cell,
    ImagePreview
} from 'vant'
import * as Config from '../../config'
import download from '../../../tool/download.js'
export default {
    name: 'Me',
    data() {
        return {
            PersonalImgUrl: null,
            TrainShow: false,
            showKeyboard: true,
            value: null,
            Show: false,
            APIFile: null,
        }
    },
    components: {
        [Popup.name]: Popup,
        [cell.name]: cell,
        [ImagePreview.name]: ImagePreview
    },
    activated() {
        this.PersonalImgUrl = this.$UserInfo.PersonalImage;
    },
    methods: {
        jump(route) {
            !!route && this.$router.push(route)
        },
        SubmitKey() {
            if (Config.secretkey === this.value) {
                this.Show = true;
                this.TrainShow = false;
            } else this.$Toast('密钥错误');
        },
        Download() {
            if (!this.APIFile) {
                this.$Toast('请输入日志名称');
                return false;
            }
            download('api/Content/log/' + this.APIFile);
        },
        DownloadWebFile() {
            this.$get('api/Property/GetApiFilePath', {
                WebFilePath: '/bl_error.txt'
            }).then(result => {
                if (result) {
                    download('api/bl_error.txt');
                } else this.$Toast("数据异常!");
            })
        },
        Delete() {
            this.$get('api/Property/DeleteFile', {
                FilePath: '/bl_error.txt'
            }).then(result => {
                this.$Toast(result.Msg);
            })
        },
        UpdateRegistration() { //更新注册码
            this.APIFile ? this.$get('api/Login/UpdateSecretKey', {
                Key: this.APIFile
            }).then(result => {
                this.$Toast(result.Msg);
            }) : this.$Toast('请输入注册码!');

        },
        ImgError() {
            this.PersonalImgUrl = require('../../assets/img/header.png');
        },
        BindWx() {
            let appid = 'wx269332d9cdb0c12b';
            let localtionUrl = window.location.href;
            var reg2 = new RegExp("#");
            let BackUrl = localtionUrl.replace(reg2, "");
            window.location.href =
                'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
                appid +
                '&redirect_uri=' +
                'http://www.api.huiyxx.com/Redirect/Index?H5Url=' + BackUrl +
                '&response_type=code&scope=snsapi_base&state=1#wechat_redirect';

        }
    },
    mounted: function () {
        let WxOpenid = this.$route.query.Openid;
        if (WxOpenid != "" && WxOpenid.length == 28) {
            this.$get('api/Login/InsOpenID', {
                UserName: this.$UserInfo.UserId,
                OpenID: WxOpenid
            }).then(result => {
                if (result == 1) {
                    let timer = setTimeout(() => {
                        this.$Toast("绑定成功");
                    }, 3000);
                    clearTimeout(timer);
                } else {
                    let timer = setTimeout(() => {
                        this.$Toast("绑定失败");
                    }, 3000);
                    clearTimeout(timer);
                }
            });
        }
    }
}
</script>

<style scoped lang="scss">
.me {
    background: $THEME-COLOR;

    .header {
        background: $THEME-COLOR;

        p {
            color: $TEXT-LIGHT-COLOR;
        }
    }

    .user-info {
        padding-top: 100px;
        display: flex;
        align-items: center;
        margin-bottom: 64px;

        .user-header {
            width: 120px;
            height: 120px;
            border-radius: 50%;
            margin-left: 56px;

            img {
                border-radius: 1em;
                width: 100%;
                height: 100%;
            }
        }

        .user-text {
            margin-left: 48px;

            p {
                color: $TEXT-LIGHT-COLOR;

                &:first-child {
                    font-size: 3.5vw;
                }

                &:last-child {
                    font-size: 4.8vw;
                    margin-top: 2vw;
                    font-weight: bold;
                }
            }
        }

        .user-right {
            img {
                position: absolute;
                top: 150px;
                left: 88%;

                width: 32px;
                height: 32px;
            }
        }
    }

    .content {
        background: $BACKGROUND-COLOR;
        padding: 46px 50px 46px 60px;
        box-sizing: border-box;
        border-radius: 24px 24px 0 0;

        &>div {
            height: 128px;
            display: flex;
            align-items: center;

            span {
                flex: 1;
                margin-left: 20px;
                color: $TEXT-DARK-COLOR;
                font-weight: bold;
            }

            img {
                &:first-child {
                    width: 54px;
                }

                &:last-child {
                    width: 32px;
                }
            }
        }
    }
}

.contentkey {

    p,
    input {
        margin-top: 20%;
    }

    p {
        color: #666666;
        text-align: right;
        font-weight: 600;
        width: 30%;
        display: inline-block;
    }

    input {
        margin-left: 30px;
        display: inline-block;
        border: 2px solid #666666;
        line-height: 50px;
    }

    div {
        line-height: 70px;
        width: 100%;
        text-align: center;
        border-radius: 1em;
        background: #4FA69E;
        color: #FFFFFF;
        position: absolute;
        bottom: 10px;
    }
}

.contentButton {
    &>div {
        border-radius: 1em;

        &:first-child {
            color: #FFFFFF;
            margin-bottom: 30px;
            margin-left: 100px;
            width: 300px;
            float: right;
            text-align: center;
            background: #4FA69E;
        }

        &:nth-child(2) {
            color: #FFFFFF;
            margin-bottom: 30px;
            margin-left: 100px;
            width: 300px;
            float: right;
            text-align: center;
            background: #4FA69E;
        }

        &:last-child {
            input {
                border: 2px solid #666666;
                line-height: 40px;
            }

            div {
                border-radius: 1em;
                color: #FFFFFF;
                float: right;
                width: 300px;
                text-align: center;
                background: #FF9E48;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/page/me/me.vue